// extracted by mini-css-extract-plugin
export default {"main":"OuterCard_main__waULD"};